
import { LoginCallback, Security } from '@okta/okta-react';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { oktaconfig } from './config';

import Footer from './components/common/Footer';
import Home from './components/home/Home';
import Confirmation from './components/confirmation/Confirmation';
import Header from './components/common/Header';
import Login from './components/Login';
import HostedFullRedirectCheckout from './components/checkout/HostedFullRedirectCheckout';
import HostedCheckoutEmbed from './components/checkout/HostedCheckoutEmbed';
import HostedSession from './components/session/HostedSession';
import Pay from './components/pay/Pay';
import ThreeDSChallenge from './components/threeds-challenge/ThreeDSChallenge';
import PayResponse from './components/checkout/PayResponse';
import CreatePaymentLink from './components/payment-link/CreatePaymentLink';
import ScrollToTop from './components/common/ScrollToTop';
import RequireAuth from './components/common/RequireAuth';

const oktaAuth = new OktaAuth(oktaconfig.oidc);

function AppWithRouterAccess() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if we're on the 3DS challenge page
  const isThreeDSChallenge = location.pathname === '/threeds-challenge';

  const restoreOriginalUriFunc = async (oktaAuth: any, originalUri: string) => {
    const uri = toRelativeUrl(originalUri || '/', window.location.origin);
    navigate(uri, { replace: true });
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUriFunc}
    >
      {!isThreeDSChallenge && <Header />}
      <div style={{ minHeight: "100vh" }}>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/login/callback" element={<LoginCallback />} />

          {/* Protected Routes */}
          <Route element={<RequireAuth />}>
            <Route path="/threeds-challenge" element={<ThreeDSChallenge />} />
            <Route path="/" element={<Home />} />
            <Route path="/checkout-redirect" element={<HostedFullRedirectCheckout embed={false} fromRoute="" />} />
            <Route path="/checkout" element={<HostedCheckoutEmbed />} />
            <Route path="/session" element={<HostedSession />} />
            <Route path="/confirmation/:orderId" element={<Confirmation />} />
            <Route path="/pay" element={<Pay />} />
            <Route path="/pay-response" element={<PayResponse />} />
            <Route path="/create-payment-link" element={<CreatePaymentLink />} />
          </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {!isThreeDSChallenge && <Footer />}
    </Security>
  );
}

export default AppWithRouterAccess;